export default "__VITE_ASSET__CFo2yJrI__"